<template>
  <v-navigation-drawer
    v-model="value"
    @input="onInput"
    color="white"
    width="360"
    app
    overflow
    fixed
    floating
    temporary
    clipped
    right
  >
    <div class="text-center px-3">
      <v-btn
        @click="$emit('input', false)"
        class="elevation-0 mt-2 text right"
        block
        outlined
      >
        <span> ปิด </span>
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </div>

    <!-- <div class="pt-2 px-3 text-right">
      <v-btn-toggle v-model="lang" color="primary" dense mandatory>
        <v-btn value="Tha">
          THA
        </v-btn>

        <v-btn value="Eng">
          ENG
        </v-btn>
      </v-btn-toggle>
    </div> -->

    <v-row>
      <v-col cols="12" class="text-center">
        <v-avatar size="192" tile>
          <span
            v-if="$userProfilePicPath.type === 'icon'"
            v-text="$userProfilePicPath.src"
            class="white--text"
            style="font-size:18px"
          />
          <v-img
            v-if="$userProfilePicPath.type === 'img'"
            :src="$userProfilePicPath.src"
            contain
          />
        </v-avatar>
      </v-col>

      <v-col cols="12" class="body-2 text-center">
        <div v-text="$useremail"></div>
        <div v-text="$username"></div>
      </v-col>

      <v-col cols="12" class="body-2 text-center">
        <v-btn
          :href="`/history/empInfo/${this.$guid_self}`"
          class="mx-1"
          small
          outlined
          rounded
          exact
        >
          ข้อมูลส่วนตัว
        </v-btn>
        <v-btn @click="logout" class="mx-1" small outlined rounded>
          ออกจากระบบ
        </v-btn>
      </v-col>
    </v-row>

    <v-divider />

    <v-tabs
      v-model="tab"
      active-class="orange--text"
      background-color="primary darken-1"
      dark
      center-active
      grow
    >
      <v-tabs-slider color="orange"></v-tabs-slider>
      <v-tab>
        <v-icon left>mdi-access-point</v-icon>
        รายการ
      </v-tab>
      <v-tab>
        <v-icon left>mdi-account</v-icon>
        ข้อมูลผู้ใช้
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-list dense>
          <v-list-item
            v-for="(menu, index) in menuList"
            @click="
              $linkPath(
                menu.otherSystem,
                menu.programCatelogPath,
                menu.programItemMenuID
              )
            "
            :key="`menu-${index}`"
            :target="menu.target"
            :disabled="!menu.programCatelogPath"
          >
            <v-list-item-icon />
            <v-list-item-title v-text="menu.programCatelogFullNameTha" />
          </v-list-item>
        </v-list>
      </v-tab-item>
      <v-tab-item>
        <div class="pt-5 px-7">สิทธิ์ในการจัดการข้อมูล</div>

        <v-list v-if="roleList.length === 0">
          <v-list-item>
            <v-list-item-icon />
            <v-list-item-title class="grey--text">
              ไม่พบสิทธิ์จัดการข้อมูล
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list v-if="roleList.length > 0">
          <v-list-item v-for="(role, index) in roleList" :key="index">
            <span class="pl-8">
              {{ role.accessRoleFullNameTha }}
            </span>
          </v-list-item>
        </v-list>
      </v-tab-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>

<script>
// import i18n from '@/plugins/i18n'

export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      menuList: [],
      roleList: [],
      tab: 0,
      lang: 'Tha'
    }
  },

  watch: {
    lang(newVal) {
      this.$root.$i18n.locale = newVal
    }
  },

  async mounted() {
    await this.getMenus()
    await this.getRoles()
  },

  methods: {
    logout() {
      localStorage.clear()
      this.$setAxiosConfig('Authorization', null)
      // window.location.href =
      //   'https://mis.cmu.ac.th/cmumis/logoutinfo.aspx?m=HRPortal'
      this.$router.push({ name: 'logout' })
    },
    async getMenus() {
      try {
        const response = await this.$store.dispatch('navbar/getUserMenus')
        if (response.data.message === 'success') {
          this.menuList = response.data.data
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async getRoles() {
      try {
        const response = await this.$store.dispatch('navbar/getUserRoles')
        if (response.data.message === 'success') {
          this.roleList = response.data.data
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onInput(e) {
      this.$emit('input', e)
    }
  }
}
</script>
